import FlashCancellationPolicies from 'components/Common/CancellationPolicies/Flash/FlashCancellationPolicies'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineShoppingCartIcon from 'components/Luxkit/Icons/line/LineShoppingCartIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import LoyaltyPoints from 'loyalty/components/LoyaltyPoints'
import { generateLoyaltyPointsCalculatorBundledFlightOptions, generateLoyaltyPointsCalculatorHotelOptions } from 'loyalty/lib/pointsCalculation/calculatorOptionsGenerators'
import React, { useMemo } from 'react'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import styled from 'styled-components'
import MultipleRoomsInclusions from '../MultipleRoomsInclusions'
import MobileMultipleRoomsBookingPriceDetails from './MobileMultipleRoomsBookingPriceDetails'

const StyledSheet = styled(Sheet)`
  min-width: 75vw;
`

interface Props {
  packageView: OfferPackageOptionView,
  offer: App.HotelOffer,
  checkIn?: string,
  availableForPurchase?: boolean,
  rooms: Array<App.RoomOccupants>,
  isFlightsSelected: boolean,
  isFlightsForAllRoomsAvailable: boolean,
}

function MobileMultipleRoomsBookingPackageOption(
  {
    packageView,
    offer,
    checkIn,
    availableForPurchase,
    rooms,
    isFlightsSelected,
    isFlightsForAllRoomsAvailable,
  }: Props,
) {
  const room = rooms[0]

  const pointsEarnCalculationRequests: [App.LoyaltyPointsEarnCalculationRequest | undefined, App.LoyaltyPointsEarnCalculationRequest | undefined] = useMemo(() => [
    generateLoyaltyPointsCalculatorHotelOptions(offer, { packageView }),
    generateLoyaltyPointsCalculatorBundledFlightOptions(offer, { packageView, skip: !isFlightsSelected }),
  ], [isFlightsSelected, offer, packageView])

  return (
    <StyledSheet
      border="neutral-six"
      padding={16}
      key={packageView.package.uniqueKey}
    >
      <Group direction="vertical" gap={8}>
        <BodyText variant="large" weight="bold">{packageView.package.name}</BodyText>
        {availableForPurchase && <FlashCancellationPolicies
          checkInDate={checkIn}
          propertyTimezoneOffset={offer.property?.timezoneOffset}
          cancellationPolicy={packageView.package.roomRate?.cancellationPolicy}
        />}
        {availableForPurchase && <MultipleRoomsInclusions
          offer={offer}
          packageOption={packageView}
        />}
        <LoyaltyPoints
          calculationRequests={pointsEarnCalculationRequests}
          calculationType={(!checkIn || isFlightsSelected) ? 'estimate' : 'exact'}
        />
        {availableForPurchase && <MobileMultipleRoomsBookingPriceDetails
          room={room}
          packageOption={packageView}
          // TODO: hook up functionality
          footerNode={
            <>
              {isFlightsForAllRoomsAvailable && (<Group direction="horizontal" gap={8} horizontalAlign="stretch">
                <TextButton kind="secondary" startIcon={<LineShoppingCartIcon />} fit="flex">Add to cart</TextButton>
                <TextButton kind="primary" fit="flex">Book {rooms.length} rooms</TextButton>
              </Group>)}
              {!isFlightsForAllRoomsAvailable && <TextButton kind="primary" fit="flex">Select {rooms.length} rooms</TextButton>}
            </>
          }
        />}

      </Group>
    </StyledSheet>
  )
}

export default MobileMultipleRoomsBookingPackageOption
